import { Router } from '@angular/router';
import { SessionStorageService } from 'ngx-webstorage';
import { VERSION } from '../../app.constants';
import { LANGUAGES } from '../../core/language/language.constants';
import { AccountService } from '../../core/auth/account.service';
import { LoginModalService } from '../../core/login/login-modal.service';
import { LoginService } from '../../core/login/login.service';
import { ProfileService } from '../../layouts/profiles/profile.service';
import { JhiLanguageService } from '../../ng-jhipster/language';
import * as i0 from "@angular/core";
import * as i1 from "../../core/login/login.service";
import * as i2 from "../../ng-jhipster/language";
import * as i3 from "ngx-webstorage";
import * as i4 from "../../core/auth/account.service";
import * as i5 from "../../core/login/login-modal.service";
import * as i6 from "../../layouts/profiles/profile.service";
import * as i7 from "@angular/router";
import * as i8 from "@angular/common";
import * as i9 from "@ng-bootstrap/ng-bootstrap";
import * as i10 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i11 from "@fortawesome/angular-fontawesome";
import * as i12 from "../../shared/auth/has-any-authority.directive";
import * as i13 from "./active-menu.directive";
import * as i14 from "../../shared/language/find-language-from-key.pipe";
const _c0 = function () { return { exact: true }; };
function NavbarComponent_nav_0_li_17_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 17);
    i0.ɵɵelementStart(1, "a", 22);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵelement(3, "fa-icon", 23);
    i0.ɵɵelementStart(4, "span", 24);
    i0.ɵɵtext(5, " Entities ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "ul", 25);
    i0.ɵɵelementStart(7, "li");
    i0.ɵɵelementStart(8, "a", 26);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(2); return ctx_r11.collapseNavbar(); });
    i0.ɵɵelement(9, "fa-icon", 27);
    i0.ɵɵelementStart(10, "span", 28);
    i0.ɵɵtext(11, "Access Log Inuka");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "li");
    i0.ɵɵelementStart(13, "a", 29);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_13_listener() { i0.ɵɵrestoreView(_r12); const ctx_r13 = i0.ɵɵnextContext(2); return ctx_r13.collapseNavbar(); });
    i0.ɵɵelement(14, "fa-icon", 27);
    i0.ɵɵelementStart(15, "span", 30);
    i0.ɵɵtext(16, "Geoip Blocks");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "li");
    i0.ɵɵelementStart(18, "a", 31);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_18_listener() { i0.ɵɵrestoreView(_r12); const ctx_r14 = i0.ɵɵnextContext(2); return ctx_r14.collapseNavbar(); });
    i0.ɵɵelement(19, "fa-icon", 27);
    i0.ɵɵelementStart(20, "span", 32);
    i0.ɵɵtext(21, "Geoip Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "li");
    i0.ɵɵelementStart(23, "a", 33);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_23_listener() { i0.ɵɵrestoreView(_r12); const ctx_r15 = i0.ɵɵnextContext(2); return ctx_r15.collapseNavbar(); });
    i0.ɵɵelement(24, "fa-icon", 27);
    i0.ɵɵelementStart(25, "span", 34);
    i0.ɵɵtext(26, "Action Plan");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "li");
    i0.ɵɵelementStart(28, "a", 35);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_28_listener() { i0.ɵɵrestoreView(_r12); const ctx_r16 = i0.ɵɵnextContext(2); return ctx_r16.collapseNavbar(); });
    i0.ɵɵelement(29, "fa-icon", 27);
    i0.ɵɵelementStart(30, "span", 36);
    i0.ɵɵtext(31, "Action Plan Item");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "li");
    i0.ɵɵelementStart(33, "a", 37);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_33_listener() { i0.ɵɵrestoreView(_r12); const ctx_r17 = i0.ɵɵnextContext(2); return ctx_r17.collapseNavbar(); });
    i0.ɵɵelement(34, "fa-icon", 27);
    i0.ɵɵelementStart(35, "span", 38);
    i0.ɵɵtext(36, "Coach Availability");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(37, "li");
    i0.ɵɵelementStart(38, "a", 39);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_38_listener() { i0.ɵɵrestoreView(_r12); const ctx_r18 = i0.ɵɵnextContext(2); return ctx_r18.collapseNavbar(); });
    i0.ɵɵelement(39, "fa-icon", 27);
    i0.ɵɵelementStart(40, "span", 40);
    i0.ɵɵtext(41, "Message");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(42, "li");
    i0.ɵɵelementStart(43, "a", 41);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_43_listener() { i0.ɵɵrestoreView(_r12); const ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.collapseNavbar(); });
    i0.ɵɵelement(44, "fa-icon", 27);
    i0.ɵɵelementStart(45, "span", 42);
    i0.ɵɵtext(46, "Notification");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(47, "li");
    i0.ɵɵelementStart(48, "a", 43);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_48_listener() { i0.ɵɵrestoreView(_r12); const ctx_r20 = i0.ɵɵnextContext(2); return ctx_r20.collapseNavbar(); });
    i0.ɵɵelement(49, "fa-icon", 27);
    i0.ɵɵelementStart(50, "span", 44);
    i0.ɵɵtext(51, "Conversationn");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(52, "li");
    i0.ɵɵelementStart(53, "a", 45);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_53_listener() { i0.ɵɵrestoreView(_r12); const ctx_r21 = i0.ɵɵnextContext(2); return ctx_r21.collapseNavbar(); });
    i0.ɵɵelement(54, "fa-icon", 27);
    i0.ɵɵelementStart(55, "span", 46);
    i0.ɵɵtext(56, "Offline Message");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(57, "li");
    i0.ɵɵelementStart(58, "a", 47);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_58_listener() { i0.ɵɵrestoreView(_r12); const ctx_r22 = i0.ɵɵnextContext(2); return ctx_r22.collapseNavbar(); });
    i0.ɵɵelement(59, "fa-icon", 27);
    i0.ɵɵelementStart(60, "span", 48);
    i0.ɵɵtext(61, "Organization Resource");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(62, "li");
    i0.ɵɵelementStart(63, "a", 49);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_63_listener() { i0.ɵɵrestoreView(_r12); const ctx_r23 = i0.ɵɵnextContext(2); return ctx_r23.collapseNavbar(); });
    i0.ɵɵelement(64, "fa-icon", 27);
    i0.ɵɵelementStart(65, "span", 50);
    i0.ɵɵtext(66, "User Organization Code");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(67, "li");
    i0.ɵɵelementStart(68, "a", 51);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_68_listener() { i0.ɵɵrestoreView(_r12); const ctx_r24 = i0.ɵɵnextContext(2); return ctx_r24.collapseNavbar(); });
    i0.ɵɵelement(69, "fa-icon", 27);
    i0.ɵɵelementStart(70, "span", 52);
    i0.ɵɵtext(71, "Organization Code");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(72, "li");
    i0.ɵɵelementStart(73, "a", 53);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_73_listener() { i0.ɵɵrestoreView(_r12); const ctx_r25 = i0.ɵɵnextContext(2); return ctx_r25.collapseNavbar(); });
    i0.ɵɵelement(74, "fa-icon", 27);
    i0.ɵɵelementStart(75, "span", 54);
    i0.ɵɵtext(76, "Rating");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(77, "li");
    i0.ɵɵelementStart(78, "a", 55);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_78_listener() { i0.ɵɵrestoreView(_r12); const ctx_r26 = i0.ɵɵnextContext(2); return ctx_r26.collapseNavbar(); });
    i0.ɵɵelement(79, "fa-icon", 27);
    i0.ɵɵelementStart(80, "span", 56);
    i0.ɵɵtext(81, "Script");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(82, "li");
    i0.ɵɵelementStart(83, "a", 57);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_83_listener() { i0.ɵɵrestoreView(_r12); const ctx_r27 = i0.ɵɵnextContext(2); return ctx_r27.collapseNavbar(); });
    i0.ɵɵelement(84, "fa-icon", 27);
    i0.ɵɵelementStart(85, "span", 58);
    i0.ɵɵtext(86, "Session");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(87, "li");
    i0.ɵɵelementStart(88, "a", 59);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_88_listener() { i0.ɵɵrestoreView(_r12); const ctx_r28 = i0.ɵɵnextContext(2); return ctx_r28.collapseNavbar(); });
    i0.ɵɵelement(89, "fa-icon", 27);
    i0.ɵɵelementStart(90, "span", 60);
    i0.ɵɵtext(91, "Srq Completed");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(92, "li");
    i0.ɵɵelementStart(93, "a", 61);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_93_listener() { i0.ɵɵrestoreView(_r12); const ctx_r29 = i0.ɵɵnextContext(2); return ctx_r29.collapseNavbar(); });
    i0.ɵɵelement(94, "fa-icon", 27);
    i0.ɵɵelementStart(95, "span", 62);
    i0.ɵɵtext(96, "Token");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(97, "li");
    i0.ɵɵelementStart(98, "a", 63);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_98_listener() { i0.ɵɵrestoreView(_r12); const ctx_r30 = i0.ɵɵnextContext(2); return ctx_r30.collapseNavbar(); });
    i0.ɵɵelement(99, "fa-icon", 27);
    i0.ɵɵelementStart(100, "span", 64);
    i0.ɵɵtext(101, "Voucher");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(102, "li");
    i0.ɵɵelementStart(103, "a", 65);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_103_listener() { i0.ɵɵrestoreView(_r12); const ctx_r31 = i0.ɵɵnextContext(2); return ctx_r31.collapseNavbar(); });
    i0.ɵɵelement(104, "fa-icon", 27);
    i0.ɵɵelementStart(105, "span", 66);
    i0.ɵɵtext(106, "User Voucher");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(107, "li");
    i0.ɵɵelementStart(108, "a", 67);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_108_listener() { i0.ɵɵrestoreView(_r12); const ctx_r32 = i0.ɵɵnextContext(2); return ctx_r32.collapseNavbar(); });
    i0.ɵɵelement(109, "fa-icon", 27);
    i0.ɵɵelementStart(110, "span", 68);
    i0.ɵɵtext(111, "Job");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(112, "li");
    i0.ɵɵelementStart(113, "a", 69);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_113_listener() { i0.ɵɵrestoreView(_r12); const ctx_r33 = i0.ɵɵnextContext(2); return ctx_r33.collapseNavbar(); });
    i0.ɵɵelement(114, "fa-icon", 27);
    i0.ɵɵelementStart(115, "span", 70);
    i0.ɵɵtext(116, "Pricing");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(117, "li");
    i0.ɵɵelementStart(118, "a", 71);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_118_listener() { i0.ɵɵrestoreView(_r12); const ctx_r34 = i0.ɵɵnextContext(2); return ctx_r34.collapseNavbar(); });
    i0.ɵɵelement(119, "fa-icon", 27);
    i0.ɵɵelementStart(120, "span", 72);
    i0.ɵɵtext(121, "Questionarre Answer");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(122, "li");
    i0.ɵɵelementStart(123, "a", 73);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_123_listener() { i0.ɵɵrestoreView(_r12); const ctx_r35 = i0.ɵɵnextContext(2); return ctx_r35.collapseNavbar(); });
    i0.ɵɵelement(124, "fa-icon", 27);
    i0.ɵɵelementStart(125, "span", 74);
    i0.ɵɵtext(126, "Resource For Help");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(127, "li");
    i0.ɵɵelementStart(128, "a", 75);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_128_listener() { i0.ɵɵrestoreView(_r12); const ctx_r36 = i0.ɵɵnextContext(2); return ctx_r36.collapseNavbar(); });
    i0.ɵɵelement(129, "fa-icon", 27);
    i0.ɵɵelementStart(130, "span", 76);
    i0.ɵɵtext(131, "Slot");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(132, "li");
    i0.ɵɵelementStart(133, "a", 77);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_133_listener() { i0.ɵɵrestoreView(_r12); const ctx_r37 = i0.ɵɵnextContext(2); return ctx_r37.collapseNavbar(); });
    i0.ɵɵelement(134, "fa-icon", 27);
    i0.ɵɵelementStart(135, "span", 78);
    i0.ɵɵtext(136, "User Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(137, "li");
    i0.ɵɵelementStart(138, "a", 79);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_138_listener() { i0.ɵɵrestoreView(_r12); const ctx_r38 = i0.ɵɵnextContext(2); return ctx_r38.collapseNavbar(); });
    i0.ɵɵelement(139, "fa-icon", 80);
    i0.ɵɵelementStart(140, "span", 81);
    i0.ɵɵtext(141, "Extra Question");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(142, "li");
    i0.ɵɵelementStart(143, "a", 82);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_143_listener() { i0.ɵɵrestoreView(_r12); const ctx_r39 = i0.ɵɵnextContext(2); return ctx_r39.collapseNavbar(); });
    i0.ɵɵelement(144, "fa-icon", 80);
    i0.ɵɵelementStart(145, "span", 83);
    i0.ɵɵtext(146, "Extra Question Option");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(147, "li");
    i0.ɵɵelementStart(148, "a", 84);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_148_listener() { i0.ɵɵrestoreView(_r12); const ctx_r40 = i0.ɵɵnextContext(2); return ctx_r40.collapseNavbar(); });
    i0.ɵɵelement(149, "fa-icon", 80);
    i0.ɵɵelementStart(150, "span", 85);
    i0.ɵɵtext(151, "Extra Question Answer");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(152, "li");
    i0.ɵɵelementStart(153, "a", 86);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_153_listener() { i0.ɵɵrestoreView(_r12); const ctx_r41 = i0.ɵɵnextContext(2); return ctx_r41.collapseNavbar(); });
    i0.ɵɵelement(154, "fa-icon", 80);
    i0.ɵɵelementStart(155, "span", 87);
    i0.ɵɵtext(156, "Organization Code Extra Question");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(157, "li");
    i0.ɵɵelementStart(158, "a", 88);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_158_listener() { i0.ɵɵrestoreView(_r12); const ctx_r42 = i0.ɵɵnextContext(2); return ctx_r42.collapseNavbar(); });
    i0.ɵɵelement(159, "fa-icon", 80);
    i0.ɵɵelementStart(160, "span", 89);
    i0.ɵɵtext(161, "Canned Messages");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(162, "li");
    i0.ɵɵelementStart(163, "a", 90);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_163_listener() { i0.ɵɵrestoreView(_r12); const ctx_r43 = i0.ɵɵnextContext(2); return ctx_r43.collapseNavbar(); });
    i0.ɵɵelement(164, "fa-icon", 80);
    i0.ɵɵelementStart(165, "span", 91);
    i0.ɵɵtext(166, "Notification Preference Admin");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(167, "li");
    i0.ɵɵelementStart(168, "a", 92);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_168_listener() { i0.ɵɵrestoreView(_r12); const ctx_r44 = i0.ɵɵnextContext(2); return ctx_r44.collapseNavbar(); });
    i0.ɵɵelement(169, "fa-icon", 80);
    i0.ɵɵelementStart(170, "span", 93);
    i0.ɵɵtext(171, "Email Feedback");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(172, "li");
    i0.ɵɵelementStart(173, "a", 94);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_173_listener() { i0.ɵɵrestoreView(_r12); const ctx_r45 = i0.ɵɵnextContext(2); return ctx_r45.collapseNavbar(); });
    i0.ɵɵelement(174, "fa-icon", 80);
    i0.ɵɵelementStart(175, "span", 95);
    i0.ɵɵtext(176, "Feedback");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(177, "li");
    i0.ɵɵelementStart(178, "a", 96);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_178_listener() { i0.ɵɵrestoreView(_r12); const ctx_r46 = i0.ɵɵnextContext(2); return ctx_r46.collapseNavbar(); });
    i0.ɵɵelement(179, "fa-icon", 80);
    i0.ɵɵelementStart(180, "span", 97);
    i0.ɵɵtext(181, "Coach Availability Preference");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(182, "li");
    i0.ɵɵelementStart(183, "a", 96);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_183_listener() { i0.ɵɵrestoreView(_r12); const ctx_r47 = i0.ɵɵnextContext(2); return ctx_r47.collapseNavbar(); });
    i0.ɵɵelement(184, "fa-icon", 80);
    i0.ɵɵelementStart(185, "span", 98);
    i0.ɵɵtext(186, "Coach Availability Preference");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(187, "li");
    i0.ɵɵelementStart(188, "a", 99);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_188_listener() { i0.ɵɵrestoreView(_r12); const ctx_r48 = i0.ɵɵnextContext(2); return ctx_r48.collapseNavbar(); });
    i0.ɵɵelement(189, "fa-icon", 80);
    i0.ɵɵelementStart(190, "span", 100);
    i0.ɵɵtext(191, "Planning Log");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(192, "li");
    i0.ɵɵelementStart(193, "a", 101);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_193_listener() { i0.ɵɵrestoreView(_r12); const ctx_r49 = i0.ɵɵnextContext(2); return ctx_r49.collapseNavbar(); });
    i0.ɵɵelement(194, "fa-icon", 80);
    i0.ɵɵelementStart(195, "span", 102);
    i0.ɵɵtext(196, "Registration");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(197, "li");
    i0.ɵɵelementStart(198, "a", 103);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_198_listener() { i0.ɵɵrestoreView(_r12); const ctx_r50 = i0.ɵɵnextContext(2); return ctx_r50.collapseNavbar(); });
    i0.ɵɵelement(199, "fa-icon", 80);
    i0.ɵɵelementStart(200, "span", 104);
    i0.ɵɵtext(201, "Security Policy");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(202, "li");
    i0.ɵɵelementStart(203, "a", 105);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_203_listener() { i0.ɵɵrestoreView(_r12); const ctx_r51 = i0.ɵɵnextContext(2); return ctx_r51.collapseNavbar(); });
    i0.ɵɵelement(204, "fa-icon", 80);
    i0.ɵɵelementStart(205, "span", 106);
    i0.ɵɵtext(206, "Tip");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(207, "li");
    i0.ɵɵelementStart(208, "a", 107);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_208_listener() { i0.ɵɵrestoreView(_r12); const ctx_r52 = i0.ɵɵnextContext(2); return ctx_r52.collapseNavbar(); });
    i0.ɵɵelement(209, "fa-icon", 80);
    i0.ɵɵelementStart(210, "span", 108);
    i0.ɵɵtext(211, "Organization Admin");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(212, "li");
    i0.ɵɵelementStart(213, "a", 109);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_213_listener() { i0.ɵɵrestoreView(_r12); const ctx_r53 = i0.ɵɵnextContext(2); return ctx_r53.collapseNavbar(); });
    i0.ɵɵelement(214, "fa-icon", 80);
    i0.ɵɵelementStart(215, "span", 110);
    i0.ɵɵtext(216, "Looking For Help Topics");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(217, "li");
    i0.ɵɵelementStart(218, "a", 111);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_218_listener() { i0.ɵɵrestoreView(_r12); const ctx_r54 = i0.ɵɵnextContext(2); return ctx_r54.collapseNavbar(); });
    i0.ɵɵelement(219, "fa-icon", 80);
    i0.ɵɵelementStart(220, "span", 112);
    i0.ɵɵtext(221, "Planning Setting");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(222, "li");
    i0.ɵɵelementStart(223, "a", 113);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_17_Template_a_click_223_listener() { i0.ɵɵrestoreView(_r12); const ctx_r55 = i0.ɵɵnextContext(2); return ctx_r55.collapseNavbar(); });
    i0.ɵɵelement(224, "fa-icon", 80);
    i0.ɵɵelementStart(225, "span", 114);
    i0.ɵɵtext(226, "External Identity Provider");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(63, _c0));
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(64, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(65, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(66, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(67, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(68, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(69, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(70, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(71, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(72, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(73, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(74, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(75, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(76, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(77, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(78, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(79, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(80, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(81, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(82, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(83, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(84, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(85, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(86, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(87, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(88, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(89, _c0));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(90, _c0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fixedWidth", true);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(91, _c0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fixedWidth", true);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(92, _c0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fixedWidth", true);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(93, _c0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fixedWidth", true);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(94, _c0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fixedWidth", true);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(95, _c0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fixedWidth", true);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(96, _c0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fixedWidth", true);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(97, _c0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fixedWidth", true);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(98, _c0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fixedWidth", true);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(99, _c0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fixedWidth", true);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(100, _c0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fixedWidth", true);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(101, _c0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fixedWidth", true);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(102, _c0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fixedWidth", true);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(103, _c0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fixedWidth", true);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(104, _c0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fixedWidth", true);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(105, _c0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fixedWidth", true);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(106, _c0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fixedWidth", true);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(107, _c0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fixedWidth", true);
} }
function NavbarComponent_nav_0_li_18_li_42_Template(rf, ctx) { if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 140);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_18_li_42_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r58); const ctx_r57 = i0.ɵɵnextContext(3); return ctx_r57.collapseNavbar(); });
    i0.ɵɵelement(2, "fa-icon", 141);
    i0.ɵɵelementStart(3, "span", 142);
    i0.ɵɵtext(4, "API");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarComponent_nav_0_li_18_Template(rf, ctx) { if (rf & 1) {
    const _r60 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 17);
    i0.ɵɵelementStart(1, "a", 115);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵelement(3, "fa-icon", 116);
    i0.ɵɵelementStart(4, "span", 117);
    i0.ɵɵtext(5, "Administration");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "ul", 118);
    i0.ɵɵelementStart(7, "li");
    i0.ɵɵelementStart(8, "a", 119);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_18_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r60); const ctx_r59 = i0.ɵɵnextContext(2); return ctx_r59.collapseNavbar(); });
    i0.ɵɵelement(9, "fa-icon", 120);
    i0.ɵɵelementStart(10, "span", 121);
    i0.ɵɵtext(11, "User management");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "li");
    i0.ɵɵelementStart(13, "a", 122);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_18_Template_a_click_13_listener() { i0.ɵɵrestoreView(_r60); const ctx_r61 = i0.ɵɵnextContext(2); return ctx_r61.collapseNavbar(); });
    i0.ɵɵelement(14, "fa-icon", 123);
    i0.ɵɵelementStart(15, "span", 124);
    i0.ɵɵtext(16, "User tracker");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "li");
    i0.ɵɵelementStart(18, "a", 125);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_18_Template_a_click_18_listener() { i0.ɵɵrestoreView(_r60); const ctx_r62 = i0.ɵɵnextContext(2); return ctx_r62.collapseNavbar(); });
    i0.ɵɵelement(19, "fa-icon", 126);
    i0.ɵɵelementStart(20, "span", 127);
    i0.ɵɵtext(21, "Metrics");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "li");
    i0.ɵɵelementStart(23, "a", 128);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_18_Template_a_click_23_listener() { i0.ɵɵrestoreView(_r60); const ctx_r63 = i0.ɵɵnextContext(2); return ctx_r63.collapseNavbar(); });
    i0.ɵɵelement(24, "fa-icon", 129);
    i0.ɵɵelementStart(25, "span", 130);
    i0.ɵɵtext(26, "Health");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "li");
    i0.ɵɵelementStart(28, "a", 131);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_18_Template_a_click_28_listener() { i0.ɵɵrestoreView(_r60); const ctx_r64 = i0.ɵɵnextContext(2); return ctx_r64.collapseNavbar(); });
    i0.ɵɵelement(29, "fa-icon", 132);
    i0.ɵɵelementStart(30, "span", 133);
    i0.ɵɵtext(31, "Configuration");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "li");
    i0.ɵɵelementStart(33, "a", 134);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_18_Template_a_click_33_listener() { i0.ɵɵrestoreView(_r60); const ctx_r65 = i0.ɵɵnextContext(2); return ctx_r65.collapseNavbar(); });
    i0.ɵɵelement(34, "fa-icon", 135);
    i0.ɵɵelementStart(35, "span", 136);
    i0.ɵɵtext(36, "Audits");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(37, "li");
    i0.ɵɵelementStart(38, "a", 137);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_18_Template_a_click_38_listener() { i0.ɵɵrestoreView(_r60); const ctx_r66 = i0.ɵɵnextContext(2); return ctx_r66.collapseNavbar(); });
    i0.ɵɵelement(39, "fa-icon", 138);
    i0.ɵɵelementStart(40, "span", 139);
    i0.ɵɵtext(41, "Logs");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(42, NavbarComponent_nav_0_li_18_li_42_Template, 5, 0, "li", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(2, _c0));
    i0.ɵɵadvance(42);
    i0.ɵɵproperty("ngIf", ctx_r2.swaggerEnabled);
} }
function NavbarComponent_nav_0_li_19_li_7_Template(rf, ctx) { if (rf & 1) {
    const _r70 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 149);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_19_li_7_Template_a_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r70); const language_r68 = restoredCtx.$implicit; const ctx_r69 = i0.ɵɵnextContext(3); ctx_r69.changeLanguage(language_r68); return ctx_r69.collapseNavbar(); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "findLanguageFromKey");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const language_r68 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiActiveMenu", language_r68);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, language_r68));
} }
function NavbarComponent_nav_0_li_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 143);
    i0.ɵɵelementStart(1, "a", 144);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵelement(3, "fa-icon", 145);
    i0.ɵɵelementStart(4, "span", 146);
    i0.ɵɵtext(5, "Language");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "ul", 147);
    i0.ɵɵtemplate(7, NavbarComponent_nav_0_li_19_li_7_Template, 4, 4, "li", 148);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngForOf", ctx_r3.languages);
} }
function NavbarComponent_nav_0_span_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "fa-icon", 150);
    i0.ɵɵelementStart(2, "span", 151);
    i0.ɵɵtext(3, " Account ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarComponent_nav_0_span_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "img", 152);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", ctx_r5.getImageUrl(), i0.ɵɵsanitizeUrl);
} }
function NavbarComponent_nav_0_li_25_Template(rf, ctx) { if (rf & 1) {
    const _r72 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 153);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_25_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r72); const ctx_r71 = i0.ɵɵnextContext(2); return ctx_r71.collapseNavbar(); });
    i0.ɵɵelement(2, "fa-icon", 154);
    i0.ɵɵelementStart(3, "span", 155);
    i0.ɵɵtext(4, "Settings");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarComponent_nav_0_li_26_Template(rf, ctx) { if (rf & 1) {
    const _r74 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 156);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_26_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r74); const ctx_r73 = i0.ɵɵnextContext(2); return ctx_r73.collapseNavbar(); });
    i0.ɵɵelement(2, "fa-icon", 157);
    i0.ɵɵelementStart(3, "span", 158);
    i0.ɵɵtext(4, "Password");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarComponent_nav_0_li_27_Template(rf, ctx) { if (rf & 1) {
    const _r76 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 159);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_27_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r76); const ctx_r75 = i0.ɵɵnextContext(2); return ctx_r75.logout(); });
    i0.ɵɵelement(2, "fa-icon", 160);
    i0.ɵɵelementStart(3, "span", 161);
    i0.ɵɵtext(4, "Sign out");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarComponent_nav_0_li_28_Template(rf, ctx) { if (rf & 1) {
    const _r78 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 162);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_28_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r78); const ctx_r77 = i0.ɵɵnextContext(2); return ctx_r77.login(); });
    i0.ɵɵelement(2, "fa-icon", 163);
    i0.ɵɵelementStart(3, "span", 164);
    i0.ɵɵtext(4, "Sign in");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarComponent_nav_0_li_29_Template(rf, ctx) { if (rf & 1) {
    const _r80 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 165);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_li_29_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r80); const ctx_r79 = i0.ɵɵnextContext(2); return ctx_r79.collapseNavbar(); });
    i0.ɵɵelement(2, "fa-icon", 166);
    i0.ɵɵelementStart(3, "span", 167);
    i0.ɵɵtext(4, "Register");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavbarComponent_nav_0_Template(rf, ctx) { if (rf & 1) {
    const _r82 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nav", 1);
    i0.ɵɵelementStart(1, "a", 2);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r82); const ctx_r81 = i0.ɵɵnextContext(); return ctx_r81.collapseNavbar(); });
    i0.ɵɵelement(2, "span", 3);
    i0.ɵɵelementStart(3, "span", 4);
    i0.ɵɵtext(4, "Inuka_ng");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 5);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "a", 6);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_Template_a_click_7_listener() { i0.ɵɵrestoreView(_r82); const ctx_r83 = i0.ɵɵnextContext(); return ctx_r83.toggleNavbar(); });
    i0.ɵɵelement(8, "fa-icon", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 8);
    i0.ɵɵelementStart(10, "ul", 9);
    i0.ɵɵelementStart(11, "li", 10);
    i0.ɵɵelementStart(12, "a", 11);
    i0.ɵɵlistener("click", function NavbarComponent_nav_0_Template_a_click_12_listener() { i0.ɵɵrestoreView(_r82); const ctx_r84 = i0.ɵɵnextContext(); return ctx_r84.collapseNavbar(); });
    i0.ɵɵelementStart(13, "span");
    i0.ɵɵelement(14, "fa-icon", 12);
    i0.ɵɵelementStart(15, "span", 13);
    i0.ɵɵtext(16, "Home");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, NavbarComponent_nav_0_li_17_Template, 227, 108, "li", 14);
    i0.ɵɵtemplate(18, NavbarComponent_nav_0_li_18_Template, 43, 3, "li", 15);
    i0.ɵɵtemplate(19, NavbarComponent_nav_0_li_19_Template, 8, 1, "li", 16);
    i0.ɵɵelementStart(20, "li", 17);
    i0.ɵɵelementStart(21, "a", 18);
    i0.ɵɵtemplate(22, NavbarComponent_nav_0_span_22_Template, 4, 0, "span", 19);
    i0.ɵɵtemplate(23, NavbarComponent_nav_0_span_23_Template, 2, 1, "span", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "ul", 20);
    i0.ɵɵtemplate(25, NavbarComponent_nav_0_li_25_Template, 5, 0, "li", 21);
    i0.ɵɵtemplate(26, NavbarComponent_nav_0_li_26_Template, 5, 0, "li", 21);
    i0.ɵɵtemplate(27, NavbarComponent_nav_0_li_27_Template, 5, 0, "li", 21);
    i0.ɵɵtemplate(28, NavbarComponent_nav_0_li_28_Template, 5, 0, "li", 21);
    i0.ɵɵtemplate(29, NavbarComponent_nav_0_li_29_Template, 5, 0, "li", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.version);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngbCollapse", ctx_r0.isNavbarCollapsed)("ngSwitch", ctx_r0.isAuthenticated());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(15, _c0));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngSwitchCase", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", "ROLE_ADMIN");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.languages && ctx_r0.languages.length > 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("routerLinkActiveOptions", i0.ɵɵpureFunction0(16, _c0));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.getImageUrl());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.getImageUrl());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitchCase", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", false);
} }
export class NavbarComponent {
    constructor(loginService, languageService, sessionStorage, accountService, loginModalService, profileService, router) {
        this.loginService = loginService;
        this.languageService = languageService;
        this.sessionStorage = sessionStorage;
        this.accountService = accountService;
        this.loginModalService = loginModalService;
        this.profileService = profileService;
        this.router = router;
        this.isNavbarCollapsed = true;
        this.languages = LANGUAGES;
        this.version = VERSION ? (VERSION.toLowerCase().startsWith('v') ? VERSION : 'v' + VERSION) : '';
        this.route = router.url;
    }
    ngOnInit() {
        this.profileService.getProfileInfo().subscribe(profileInfo => {
            this.inProduction = profileInfo.inProduction;
            this.swaggerEnabled = profileInfo.swaggerEnabled;
        });
    }
    changeLanguage(languageKey) {
        this.sessionStorage.store('locale', languageKey);
        this.languageService.changeLanguage(languageKey);
    }
    collapseNavbar() {
        this.isNavbarCollapsed = true;
    }
    isAuthenticated() {
        return this.accountService.isAuthenticated();
    }
    login() {
        this.loginModalService.open();
    }
    logout() {
        this.collapseNavbar();
        this.loginService.logout();
        this.router.navigate(['']);
    }
    toggleNavbar() {
        this.isNavbarCollapsed = !this.isNavbarCollapsed;
    }
    getImageUrl() {
        return this.isAuthenticated() ? this.accountService.getImageUrl() : '';
    }
}
NavbarComponent.ɵfac = function NavbarComponent_Factory(t) { return new (t || NavbarComponent)(i0.ɵɵdirectiveInject(i1.LoginService), i0.ɵɵdirectiveInject(i2.JhiLanguageService), i0.ɵɵdirectiveInject(i3.SessionStorageService), i0.ɵɵdirectiveInject(i4.AccountService), i0.ɵɵdirectiveInject(i5.LoginModalService), i0.ɵɵdirectiveInject(i6.ProfileService), i0.ɵɵdirectiveInject(i7.Router)); };
NavbarComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NavbarComponent, selectors: [["jhi-navbar"]], decls: 1, vars: 1, consts: [["class", "navbar navbar-dark navbar-expand-md bg-primary", 4, "ngIf"], [1, "navbar", "navbar-dark", "navbar-expand-md", "bg-primary"], ["routerLink", "/", 1, "navbar-brand", "logo", 3, "click"], [1, "logo-img"], ["jhiTranslate", "global.title", 1, "navbar-title"], [1, "navbar-version"], ["href", "javascript:void(0);", "data-toggle", "collapse", "data-target", "#navbarResponsive", "aria-controls", "navbarResponsive", "aria-expanded", "false", "aria-label", "Toggle navigation", 1, "navbar-toggler", "d-lg-none", 3, "click"], ["icon", "bars"], ["id", "navbarResponsive", 1, "navbar-collapse", "collapse", 3, "ngbCollapse", "ngSwitch"], [1, "navbar-nav", "ml-auto"], ["routerLinkActive", "active", 1, "nav-item", 3, "routerLinkActiveOptions"], ["routerLink", "/", 1, "nav-link", 3, "click"], ["icon", "home"], ["jhiTranslate", "global.menu.home"], ["ngbDropdown", "", "class", "nav-item dropdown pointer", "display", "dynamic", "routerLinkActive", "active", 3, "routerLinkActiveOptions", 4, "ngSwitchCase"], ["ngbDropdown", "", "class", "nav-item dropdown pointer", "display", "dynamic", "routerLinkActive", "active", 3, "routerLinkActiveOptions", 4, "jhiHasAnyAuthority"], ["ngbDropdown", "", "class", "nav-item dropdown pointer", "display", "dynamic", 4, "ngIf"], ["ngbDropdown", "", "display", "dynamic", "routerLinkActive", "active", 1, "nav-item", "dropdown", "pointer", 3, "routerLinkActiveOptions"], ["ngbDropdownToggle", "", "href", "javascript:void(0);", "id", "account-menu", 1, "nav-link", "dropdown-toggle"], [4, "ngIf"], ["ngbDropdownMenu", "", "aria-labelledby", "account-menu", 1, "dropdown-menu"], [4, "ngSwitchCase"], ["ngbDropdownToggle", "", "href", "javascript:void(0);", "id", "entity-menu", 1, "nav-link", "dropdown-toggle"], ["icon", "th-list"], ["jhiTranslate", "global.menu.entities.main"], ["ngbDropdownMenu", "", "aria-labelledby", "entity-menu", 1, "dropdown-menu"], ["routerLink", "access-log-inuka", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["icon", "asterisk", "fixedWidth", "true"], ["jhiTranslate", "global.menu.entities.accessLogInuka"], ["routerLink", "geoip-blocks", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.geoipBlocks"], ["routerLink", "geoip-country", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.geoipCountry"], ["routerLink", "action-plan", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.actionPlan"], ["routerLink", "action-plan-item", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.actionPlanItem"], ["routerLink", "coach-availability", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.coachAvailability"], ["routerLink", "message", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.message"], ["routerLink", "notification", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.notification"], ["routerLink", "conversationn", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.conversationn"], ["routerLink", "offline-message", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.offlineMessage"], ["routerLink", "organization-resource", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.organizationResource"], ["routerLink", "user-organization-code", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.userOrganizationCode"], ["routerLink", "organization-code", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.organizationCode"], ["routerLink", "rating", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.rating"], ["routerLink", "script", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.script"], ["routerLink", "session", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.session"], ["routerLink", "srq-completed", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.srqCompleted"], ["routerLink", "token", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.token"], ["routerLink", "voucher", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.voucher"], ["routerLink", "user-voucher", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.userVoucher"], ["routerLink", "job", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.job"], ["routerLink", "pricing", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.pricing"], ["routerLink", "questionarre-answer", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.questionarreAnswer"], ["routerLink", "resource-for-help", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.resourceForHelp"], ["routerLink", "slot", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.slot"], ["routerLink", "user-details", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.userDetails"], ["routerLink", "extra-question", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["icon", "asterisk", 3, "fixedWidth"], ["jhiTranslate", "global.menu.entities.extraQuestion"], ["routerLink", "extra-question-option", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.extraQuestionOption"], ["routerLink", "extra-question-answer", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.extraQuestionAnswer"], ["routerLink", "organization-code-extra-question", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.organizationCodeExtraQuestion"], ["routerLink", "canned-messages", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.adminCannedMessages"], ["routerLink", "notification-preference-admin", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.notificationPreferenceAdmin"], ["routerLink", "email-feedback", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.adminEmailFeedback"], ["routerLink", "feedback", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.adminFeedback"], ["routerLink", "coach-availability-preference", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.trueCoachAvailabilityPreference"], ["jhiTranslate", "global.menu.entities.adminCoachAvailabilityPreference"], ["routerLink", "planning-log", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.planningLog"], ["routerLink", "registration", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.registration"], ["routerLink", "security-policy", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.securityPolicy"], ["routerLink", "tip", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.tip"], ["routerLink", "organization-admin", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.organizationAdmin"], ["routerLink", "looking-for-help-topics", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.lookingForHelpTopics"], ["routerLink", "planning-setting", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.planningSetting"], ["routerLink", "external-identity-provider", "routerLinkActive", "active", 1, "dropdown-item", 3, "routerLinkActiveOptions", "click"], ["jhiTranslate", "global.menu.entities.externalIdentityProvider"], ["ngbDropdownToggle", "", "href", "javascript:void(0);", "id", "admin-menu", 1, "nav-link", "dropdown-toggle"], ["icon", "user-plus"], ["jhiTranslate", "global.menu.admin.main"], ["ngbDropdownMenu", "", "aria-labelledby", "admin-menu", 1, "dropdown-menu"], ["routerLink", "admin/user-management", "routerLinkActive", "active", 1, "dropdown-item", 3, "click"], ["icon", "user", "fixedWidth", "true"], ["jhiTranslate", "global.menu.admin.userManagement"], ["routerLink", "admin/tracker", "routerLinkActive", "active", 1, "dropdown-item", 3, "click"], ["icon", "eye", "fixedWidth", "true"], ["jhiTranslate", "global.menu.admin.tracker"], ["routerLink", "admin/metrics", "routerLinkActive", "active", 1, "dropdown-item", 3, "click"], ["icon", "tachometer-alt", "fixedWidth", "true"], ["jhiTranslate", "global.menu.admin.metrics"], ["routerLink", "admin/health", "routerLinkActive", "active", 1, "dropdown-item", 3, "click"], ["icon", "heart", "fixedWidth", "true"], ["jhiTranslate", "global.menu.admin.health"], ["routerLink", "admin/configuration", "routerLinkActive", "active", 1, "dropdown-item", 3, "click"], ["icon", "list", "fixedWidth", "true"], ["jhiTranslate", "global.menu.admin.configuration"], ["routerLink", "admin/audits", "routerLinkActive", "active", 1, "dropdown-item", 3, "click"], ["icon", "bell", "fixedWidth", "true"], ["jhiTranslate", "global.menu.admin.audits"], ["routerLink", "admin/logs", "routerLinkActive", "active", 1, "dropdown-item", 3, "click"], ["icon", "tasks", "fixedWidth", "true"], ["jhiTranslate", "global.menu.admin.logs"], ["routerLink", "admin/docs", "routerLinkActive", "active", 1, "dropdown-item", 3, "click"], ["icon", "book", "fixedWidth", "true"], ["jhiTranslate", "global.menu.admin.apidocs"], ["ngbDropdown", "", "display", "dynamic", 1, "nav-item", "dropdown", "pointer"], ["ngbDropdownToggle", "", "href", "javascript:void(0);", "id", "languagesnavBarDropdown", 1, "nav-link", "dropdown-toggle"], ["icon", "flag"], ["jhiTranslate", "global.menu.language"], ["ngbDropdownMenu", "", "aria-labelledby", "languagesnavBarDropdown", 1, "dropdown-menu"], [4, "ngFor", "ngForOf"], ["href", "javascript:void(0);", 1, "dropdown-item", 3, "jhiActiveMenu", "click"], ["icon", "user"], ["jhiTranslate", "global.menu.account.main"], ["alt", "Avatar", 1, "profile-image", "rounded-circle", 3, "src"], ["routerLink", "account/settings", "routerLinkActive", "active", 1, "dropdown-item", 3, "click"], ["icon", "wrench", "fixedWidth", "true"], ["jhiTranslate", "global.menu.account.settings"], ["routerLink", "account/password", "routerLinkActive", "active", 1, "dropdown-item", 3, "click"], ["icon", "lock", "fixedWidth", "true"], ["jhiTranslate", "global.menu.account.password"], ["id", "logout", 1, "dropdown-item", 3, "click"], ["icon", "sign-out-alt", "fixedWidth", "true"], ["jhiTranslate", "global.menu.account.logout"], ["id", "login", 1, "dropdown-item", 3, "click"], ["icon", "sign-in-alt", "fixedWidth", "true"], ["jhiTranslate", "global.menu.account.login"], ["routerLink", "account/register", "routerLinkActive", "active", 1, "dropdown-item", 3, "click"], ["icon", "user-plus", "fixedWidth", "true"], ["jhiTranslate", "global.menu.account.register"]], template: function NavbarComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, NavbarComponent_nav_0_Template, 30, 17, "nav", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.isAuthenticated());
    } }, directives: [i8.NgIf, i9.NgbNavbar, i7.RouterLinkWithHref, i10.JhiTranslateDirective, i11.FaIconComponent, i9.NgbCollapse, i8.NgSwitch, i7.RouterLinkActive, i8.NgSwitchCase, i12.HasAnyAuthorityDirective, i9.NgbDropdown, i9.NgbDropdownToggle, i9.NgbDropdownMenu, i8.NgForOf, i13.ActiveMenuDirective], pipes: [i14.FindLanguageFromKeyPipe], styles: ["var[_ngcontent-%COMP%]   resource[_ngcontent-%COMP%];\n (()[_ngcontent-%COMP%]   =[_ngcontent-%COMP%] >  { // webpackBootstrap\n \tvar __webpack_modules__ = ({\n\n 529:\n ((module) => {\n\n\"use strict\";\n\n\n\nmodule.exports = function (cssWithMappingToString) {\n  var list = [];\n\n  // return the list of modules as css string\n  list.toString = function toString() {\n    return this.map(function (item) {\n      var content = \"\";\n      var needLayer = typeof item[5] !== \"undefined\";\n      if (item[4]) {\n        content += \"@supports (\".concat(item[4], \") {\");\n      }\n      if (item[2]) {\n        content += \"@media \".concat(item[2], \" {\");\n      }\n      if (needLayer) {\n        content += \"@layer\".concat(item[5].length > 0 ? \" \".concat(item[5]) : \"\", \" {\");\n      }\n      content += cssWithMappingToString(item);\n      if (needLayer) {\n        content += \"}\";\n      }\n      if (item[2]) {\n        content += \"}\";\n      }\n      if (item[4]) {\n        content += \"}\";\n      }\n      return content;\n    }).join(\"\");\n  };\n\n  // import a list of modules into the list\n  list.i = function i(modules, media, dedupe, supports, layer) {\n    if (typeof modules === \"string\") {\n      modules = [[null, modules, undefined]];\n    }\n    var alreadyImportedModules = {};\n    if (dedupe) {\n      for (var k = 0; k < this.length; k++) {\n        var id = this[k][0];\n        if (id != null) {\n          alreadyImportedModules[id] = true;\n        }\n      }\n    }\n    for (var _k = 0; _k < modules.length; _k++) {\n      var item = [].concat(modules[_k]);\n      if (dedupe && alreadyImportedModules[item[0]]) {\n        continue;\n      }\n      if (typeof layer !== \"undefined\") {\n        if (typeof item[5] === \"undefined\") {\n          item[5] = layer;\n        } else {\n          item[1] = \"@layer\".concat(item[5].length > 0 ? \" \".concat(item[5]) : \"\", \" {\").concat(item[1], \"}\");\n          item[5] = layer;\n        }\n      }\n      if (media) {\n        if (!item[2]) {\n          item[2] = media;\n        } else {\n          item[1] = \"@media \".concat(item[2], \" {\").concat(item[1], \"}\");\n          item[2] = media;\n        }\n      }\n      if (supports) {\n        if (!item[4]) {\n          item[4] = \"\".concat(supports);\n        } else {\n          item[1] = \"@supports (\".concat(item[4], \") {\").concat(item[1], \"}\");\n          item[4] = supports;\n        }\n      }\n      list.push(item);\n    }\n  };\n  return list;\n};\n\n }),\n\n 943:\n ((module) => {\n\n\"use strict\";\n\n\nmodule.exports = function (url, options) {\n  if (!options) {\n    options = {};\n  }\n  if (!url) {\n    return url;\n  }\n  url = String(url.__esModule ? url.default : url);\n\n  // If url is already wrapped in quotes, remove them\n  if (/^['\"].*['\"]$/.test(url)) {\n    url = url.slice(1, -1);\n  }\n  if (options.hash) {\n    url += options.hash;\n  }\n\n  // Should url be wrapped?\n  // See https://drafts.csswg.org/css-values-3/#urls\n  if (/[\"'() \\t\\n]|(%20)/.test(url) || options.needQuotes) {\n    return \"\\\"\".concat(url.replace(/\"/g, '\\\\\"').replace(/\\n/g, \"\\\\n\"), \"\\\"\");\n  }\n  return url;\n};\n\n }),\n\n 978:\n ((module) => {\n\n\"use strict\";\n\n\nmodule.exports = function (item) {\n  var content = item[1];\n  var cssMapping = item[3];\n  if (!cssMapping) {\n    return content;\n  }\n  if (typeof btoa === \"function\") {\n    var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(cssMapping))));\n    var data = \"sourceMappingURL=data:application/json;charset=utf-8;base64,\".concat(base64);\n    var sourceMapping = \"\");\n    return [content].concat([sourceMapping]).join(\"\\n\");\n  }\n  return [content].join(\"\\n\");\n};\n\n }),\n\n 917:\n ((module, __webpack_exports__, __webpack_require__) => {\n\n\"use strict\";\n__webpack_require__.r(__webpack_exports__);\n __webpack_require__.d(__webpack_exports__, {\n   \"default\": () => (__WEBPACK_DEFAULT_EXPORT__)\n });\n var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(978);\n var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);\n var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(529);\n var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);\n var _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(943);\n var _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2__);\n// Imports\n\n\n\nvar ___CSS_LOADER_URL_IMPORT_0___ = new URL( __webpack_require__(434), __webpack_require__.b);\nvar ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));\nvar ___CSS_LOADER_URL_REPLACEMENT_0___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_0___);\n// Module\n___CSS_LOADER_EXPORT___.push([module.id, \".navbar-version{font-size:.65em;color:rgba(255,255,255,.6)}.profile-image{height:1.75em;width:1.75em}.navbar{padding:.2rem 1rem}.navbar .dropdown-item.active,.navbar .dropdown-item.active:focus,.navbar .dropdown-item.active:hover{background-color:#343a40}.navbar ul.navbar-nav .nav-item{margin-left:.5em}.navbar a.nav-link{font-weight:400}.navbar .navbar-toggler:hover{color:#fff}.logo-img{height:45px;width:45px;display:inline-block;vertical-align:middle;background:url(\" + ___CSS_LOADER_URL_REPLACEMENT_0___ + \") no-repeat center center;background-size:contain}\", \"\",{\"version\":3,\"sources\":[\"webpack://./src/main/webapp/app/layouts/navbar/navbar.scss\",\"webpack://./node_modules/bootswatch/dist/minty/_variables.scss\"],\"names\":[],\"mappings\":\"AAQA,gBACE,eAAA,CACA,0BCyDkC,CDtDpC,eACE,aAAA,CACA,YAAA,CAGF,QACE,kBAAA,CACA,sGAGE,wBCRO,CDYP,gCACE,gBAAA,CAIJ,mBACE,eAAA,CAIA,8BACE,UC/BK,CDuCX,UACE,WAAA,CACA,UAAA,CACA,oBAAA,CACA,qBAAA,CACA,0EAAA,CACA,uBAAA\",\"sourcesContent\":[\"@import '~bootstrap/scss/functions';\\n@import '~bootswatch/dist/minty/variables';\\n@import '~bootstrap/scss/variables';\\n\\n\\n\\n.navbar-version {\\n  font-size: 0.65em;\\n  color: $navbar-dark-color;\\n}\\n\\n.profile-image {\\n  height: 1.75em;\\n  width: 1.75em;\\n}\\n\\n.navbar {\\n  padding: 0.2rem 1rem;\\n  .dropdown-item.active,\\n  .dropdown-item.active:focus,\\n  .dropdown-item.active:hover {\\n    background-color: $dark;\\n  }\\n\\n  ul.navbar-nav {\\n    .nav-item {\\n      margin-left: 0.5em;\\n    }\\n  }\\n\\n  a.nav-link {\\n    font-weight: 400;\\n  }\\n\\n  .navbar-toggler {\\n    &:hover {\\n      color: $navbar-dark-hover-color;\\n    }\\n  }\\n}\\n\\n\\n.logo-img {\\n  height: 45px;\\n  width: 45px;\\n  display: inline-block;\\n  vertical-align: middle;\\n  background: url('../../../content/images/logo-jhipster.png') no-repeat center center;\\n  background-size: contain;\\n}\\n\",\"// Minty 4.3.1\\n// Bootswatch\\n\\n//\\n// Color system\\n//\\n\\n$white:    #fff !default;\\n$gray-100: #f8f9fa !default;\\n$gray-200: #f7f7f9 !default;\\n$gray-300: #eceeef !default;\\n$gray-400: #ced4da !default;\\n$gray-500: #aaa !default;\\n$gray-600: #888 !default;\\n$gray-700: #5a5a5a !default;\\n$gray-800: #343a40 !default;\\n$gray-900: #212529 !default;\\n$black:    #000 !default;\\n\\n$blue:    #007bff !default;\\n$indigo:  #6610f2 !default;\\n$purple:  #6f42c1 !default;\\n$pink:    #e83e8c !default;\\n$red:     #FF7851 !default;\\n$orange:  #fd7e14 !default;\\n$yellow:  #FFCE67 !default;\\n$green:   #56CC9D !default;\\n$teal:    #20c997 !default;\\n$cyan:    #6CC3D5 !default;\\n\\n$primary:       #78C2AD !default;\\n$secondary:     #F3969A !default;\\n$success:       $green !default;\\n$info:          $cyan !default;\\n$warning:       $yellow !default;\\n$danger:        $red !default;\\n$light:         $gray-100 !default;\\n$dark:          $gray-800 !default;\\n\\n$yiq-contrasted-threshold: 250 !default;\\n\\n// Body\\n\\n$body-color:                $gray-600 !default;\\n\\n// Components\\n\\n$border-radius:               .4rem !default;\\n$border-radius-lg:            .6rem !default;\\n$border-radius-sm:            .3rem !default;\\n\\n// Fonts\\n\\n$headings-font-family:        \\\"Montserrat\\\", -apple-system, system-ui, BlinkMacSystemFont, \\\"Segoe UI\\\", Roboto, \\\"Helvetica Neue\\\", Arial, sans-serif !default;\\n$headings-color:              $gray-700 !default;\\n\\n// Tables\\n\\n$table-border-color:          rgba(0,0,0,0.05) !default;\\n\\n// Dropdowns\\n\\n$dropdown-link-hover-color:         $white !default;\\n$dropdown-link-hover-bg:            $secondary !default;\\n\\n// Navbar\\n\\n$navbar-dark-color:                 rgba($white,.6) !default;\\n$navbar-dark-hover-color:           $white !default;\\n\\n$navbar-light-color:                rgba($black,.3) !default;\\n$navbar-light-hover-color:          $gray-700 !default;\\n$navbar-light-active-color:         $gray-700 !default;\\n$navbar-light-disabled-color:       rgba($black,.1) !default;\\n\\n// Pagination\\n\\n$pagination-color:                  $white !default;\\n$pagination-bg:                     $primary !default;\\n$pagination-border-color:           $primary !default;\\n\\n$pagination-hover-color:            $white !default;\\n$pagination-hover-bg:               $secondary !default;\\n$pagination-hover-border-color:     $pagination-hover-bg !default;\\n\\n$pagination-active-bg:              $secondary !default;\\n$pagination-active-border-color:    $pagination-active-bg !default;\\n\\n$pagination-disabled-color:         $white !default;\\n$pagination-disabled-bg:            #CCE8E0 !default;\\n$pagination-disabled-border-color:  $pagination-disabled-bg !default;\\n\\n// Breadcrumbs\\n\\n$breadcrumb-bg:                     $primary !default;\\n$breadcrumb-divider-color:          $white !default;\\n$breadcrumb-active-color:           $breadcrumb-divider-color !default;\\n\"],\"sourceRoot\":\"\"}]);\n// Exports\n const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);\n\n\n }),\n\n 434:\n ((module, __unused_webpack_exports, __webpack_require__) => {\n\n\"use strict\";\nmodule.exports = __webpack_require__.p + \"ac4146c5d39bd4538600.png\";\n\n }),\n\n 949:\n ((module, __unused_webpack_exports, __webpack_require__) => {\n\n\n        var result = __webpack_require__(917);\n\n        if (result && result.__esModule) {\n            result = result.default;\n        }\n\n        if (typeof result === \"string\") {\n            module.exports = result;\n        } else {\n            module.exports = result.toString();\n        }\n    \n\n })\n\n \t});\n\n \t// The module cache\n \tvar __webpack_module_cache__ = {};\n \t\n \t// The require function\n \tfunction __webpack_require__(moduleId) {\n \t\t// Check if module is in cache\n \t\tvar cachedModule = __webpack_module_cache__[moduleId];\n \t\tif (cachedModule !== undefined) {\n \t\t\treturn cachedModule.exports;\n \t\t}\n \t\t// Create a new module (and put it into the cache)\n \t\tvar module = __webpack_module_cache__[moduleId] = {\n \t\t\tid: moduleId,\n \t\t\t// no module.loaded needed\n \t\t\texports: {}\n \t\t};\n \t\n \t\t// Execute the module function\n \t\t__webpack_modules__[moduleId](module, module.exports, __webpack_require__);\n \t\n \t\t// Return the exports of the module\n \t\treturn module.exports;\n \t}\n \t\n \t// expose the modules object (__webpack_modules__)\n \t__webpack_require__.m = __webpack_modules__;\n \t\n\n \t\n \t(() => {\n \t\t// getDefaultExport function for compatibility with non-harmony modules\n \t\t__webpack_require__.n = (module) => {\n \t\t\tvar getter = module && module.__esModule ?\n \t\t\t\t() => (module['default']) :\n \t\t\t\t() => (module);\n \t\t\t__webpack_require__.d(getter, { a: getter });\n \t\t\treturn getter;\n \t\t};\n \t})();\n \t\n \t\n \t(() => {\n \t\t// define getter functions for harmony exports\n \t\t__webpack_require__.d = (exports, definition) => {\n \t\t\tfor(var key in definition) {\n \t\t\t\tif(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {\n \t\t\t\t\tObject.defineProperty(exports, key, { enumerable: true, get: definition[key] });\n \t\t\t\t}\n \t\t\t}\n \t\t};\n \t})();\n \t\n \t\n \t(() => {\n \t\t__webpack_require__.g = (function() {\n \t\t\tif (typeof globalThis === 'object') return globalThis;\n \t\t\ttry {\n \t\t\t\treturn this || new Function('return this')();\n \t\t\t} catch (e) {\n \t\t\t\tif (typeof window === 'object') return window;\n \t\t\t}\n \t\t})();\n \t})();\n \t\n \t\n \t(() => {\n \t\t__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))\n \t})();\n \t\n \t\n \t(() => {\n \t\t// define __esModule on exports\n \t\t__webpack_require__.r = (exports) => {\n \t\t\tif(typeof Symbol !== 'undefined' && Symbol.toStringTag) {\n \t\t\t\tObject.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });\n \t\t\t}\n \t\t\tObject.defineProperty(exports, '__esModule', { value: true });\n \t\t};\n \t})();\n \t\n \t\n \t(() => {\n \t\tvar scriptUrl;\n \t\tif (__webpack_require__.g.importScripts) scriptUrl = __webpack_require__.g.location + \"\";\n \t\tvar document = __webpack_require__.g.document;\n \t\tif (!scriptUrl && document) {\n \t\t\tif (document.currentScript)\n \t\t\t\tscriptUrl = document.currentScript.src\n \t\t\tif (!scriptUrl) {\n \t\t\t\tvar scripts = document.getElementsByTagName(\"script\");\n \t\t\t\tif(scripts.length) scriptUrl = scripts[scripts.length - 1].src\n \t\t\t}\n \t\t}\n \t\t// When supporting browsers where an automatic publicPath is not supported you must specify an output.publicPath manually via configuration\n \t\t// or pass an empty string (\"\") and set the __webpack_public_path__ variable from your code to use your own logic.\n \t\tif (!scriptUrl) throw new Error(\"Automatic publicPath is not supported in this browser\");\n \t\tscriptUrl = scriptUrl.replace(/#.*$/, \"\").replace(/\\?.*$/, \"\").replace(/\\/[^\\/]+$/, \"/\");\n \t\t__webpack_require__.p = scriptUrl + \"../../../../../../../../../../../../../\";\n \t})();\n \t\n \t\n \t(() => {\n \t\t__webpack_require__.b = require(\"url\").pathToFileURL(__dirname + \"/../../../../../../../../../../../../../\");\n \t\t\n \t\t// object to store loaded chunks\n \t\t// \"1\" means \"loaded\", otherwise not loaded yet\n \t\tvar installedChunks = {\n \t\t\t105: 1\n \t\t};\n \t\t\n \t\t// no on chunks loaded\n \t\t\n \t\t// no chunk install function needed\n \t\t\n \t\t// no chunk loading\n \t\t\n \t\t// no external install chunk\n \t\t\n \t\t// no HMR\n \t\t\n \t\t// no HMR manifest\n \t})();\n \t\n\n \t\n \t// startup\n \t// Load entry module and return exports\n \t// This entry module is referenced by other modules so it can't be inlined\n \tvar __webpack_exports__ = __webpack_require__(949);\n \tresource = __webpack_exports__;\n \t\n })()\n;"] });
